import { render, staticRenderFns } from "./ChoiceMultiple.vue?vue&type=template&id=5aabbd23&"
import script from "./ChoiceMultiple.vue?vue&type=script&lang=js&"
export * from "./ChoiceMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports